@let showMainContent = !isRDMode && (!isOffline || isEdit);

<form
  class="mbs-wizard_form"
  [formGroup]="stepForm">
  @if (isOffline) {
    <mbs-alert
      class="isOfflineAlert"
      [icon]="true"
      [type]="mbsPopupType.warning">
      {{ 'wizards:select_virtual_machines_offline_alert' | i18next }}
    </mbs-alert>
  }

  @if (isHyperV && hyperVNotInstalled) {
    <mbs-alert
      [icon]="true"
      [type]="mbsPopupType.warning">
      {{ 'wizards:hyperVNotInstalled' | i18next }}
    </mbs-alert>
  }

  <mbs-form-group class="position-relative">
    <mbs-radio
      formControlName="type"
      name="VirtualMachinesSelectedType"
      [id]="elementsSelector.id.allRadio"
      [label]="'wizards:select_all_virtual_machines' | i18next"
      [value]="virtualMachinesSelectedType.All"
      (change)="typeChangeHandler(virtualMachinesSelectedType.All)"></mbs-radio>
    <mbs-radio
      formControlName="type"
      name="VirtualMachinesSelectedType"
      [id]="elementsSelector.id.runningRadio"
      [label]="'wizards:select_running_virtual_machines' | i18next"
      [value]="virtualMachinesSelectedType.Running"
      (change)="typeChangeHandler(virtualMachinesSelectedType.Running)"></mbs-radio>

    @if (showMainContent) {
      <mbs-radio
        formControlName="type"
        name="VirtualMachinesSelectedType"
        [id]="elementsSelector.id.selectedRadio"
        [label]="'wizards:select_selected_virtual_machines' | i18next"
        [value]="virtualMachinesSelectedType.Selected"
        (change)="typeChangeHandler(virtualMachinesSelectedType.Selected)"></mbs-radio>
    }

    @if (showMainContent && value?.type === virtualMachinesSelectedType.Selected) {
      <mbs-button
        #searchTooltip="ngbTooltip"
        class="position-absolute end-0 bottom-0"
        container="body"
        placement="left auto"
        [icon]="'fa fa-external-link-square'"
        [id]="elementsSelector.id.searchButton"
        [isCtrl]="true"
        [loading]="machinesLoading"
        [ngbTooltip]="'wizards:searchVirtualMachinesButton' | i18next"
        [size]="MbsSize.lg"
        [type]="'dark'"
        (click)="openSearchMachinesModal(searchTooltip)"></mbs-button>
    }
  </mbs-form-group>

  @if (showMainContent) {
    <mbs-form-group class="mb-0">
      <mbs-list-select
        bindSelected="virtualMachineId"
        id="virtual-machines-list"
        [attr.data-e2e]="elementsSelector.name.vmListSelect"
        [data]="loadedMachines"
        [headers]="headers"
        [invalid]="stepForm.touched && value?.type === virtualMachinesSelectedType.Selected && !value?.machines?.length"
        [keepState]="true"
        [loading]="machinesLoading"
        [maxHeight]="'calc(70vh - ' + minusPixels + 'px)'"
        [selectable]="value?.type === virtualMachinesSelectedType.Selected"
        [selectedData]="selectedMachines"
        [showCheckboxes]="value?.type === virtualMachinesSelectedType.Selected"
        [showSearch]="false"
        [showTopControls]="value?.type === virtualMachinesSelectedType.Selected"
        [topControlsLabel]="true"
        [virtualItemSize]="40"
        [virtualItemsNumber]="10"
        [virtualScrolling]="true"
        (changeSelected)="selectedMachinesChangesHandler($event)"
        (scrolledIndexChange)="scrolledIndexChangeHandler($event)">
        <ng-template prependTopControlsLabel>
          <strong>
            {{
              isOffline
                ? ('wizards:selected_virtual_machines_offline' | i18next: { selected: selectedMachines.length })
                : ('wizards:selected_virtual_machines' | i18next: { selected: selectedMachines.length, all: machinesTotal })
            }}
          </strong>
        </ng-template>
        <ng-template
          let-machine
          mbsTableCell>
          <div class="form-row">
            <div class="col overflow-hidden">
              <div class="d-flex align-items-center">
                <img
                  class="mr-2"
                  [alt]="machine[fieldName] + (machine.clusterVm ? ('wizards:selectedVMCluster' | i18next) : '')"
                  [src]="isProxmox && machine.itemType === itemTypeEnum.Container ? proxmoxContainerIcon : virtualMachinesIcon" />
                <mbs-text-ellipsis [tooltip]="machine[fieldName]">
                  {{ machine[fieldName] }}{{ machine.clusterVm ? ('wizards:selectedVMCluster' | i18next) : '' }}
                </mbs-text-ellipsis>
              </div>
            </div>

            @if (machine.invalidName) {
              <div class="col-auto d-flex align-items-center">
                <span
                  class="fa fa-info-circle tooltip-btn text-danger ml-1"
                  container="body"
                  placement="top"
                  [ngbTooltip]="'wizards:selected_virtual_machines_identical_names' | i18next"></span>
              </div>
            }

            @if (!machine.invalidName && machine.invalidDisks) {
              <div class="col-auto d-flex align-items-center">
                <span
                  class="fa fa-info-circle tooltip-btn text-danger ml-1"
                  container="body"
                  placement="top"
                  [ngbTooltip]="'wizards:selected_virtual_machines_void_disks' | i18next"></span>
              </div>
            }
          </div>
        </ng-template>
      </mbs-list-select>

      @if (notLoaded && (!isEdit || !notLoadedSelected)) {
        <mbs-button
          class="mt-2"
          type="primary"
          [icon]="'ico ico-Refresh'"
          [isCtrl]="true"
          [loading]="machinesLoading"
          (click)="loadMachines(true)">
          {{ 'wizards:loadMoreVirtualMachines' | i18next: { count: notLoaded } }}
        </mbs-button>
      }

      @if (isEdit && notLoaded && notLoadedSelected) {
        <mbs-alert
          class="loadingDisksAlert mt-2"
          [icon]="true"
          [type]="mbsPopupType.info">
          <span class="d-flex align-items-center overflow-hidden fw-bold mb-1">
            {{ 'wizards:pleaseWaitLoadingMachines1' | i18next }} <span class="loader ml-2"></span>
          </span>
          {{ 'wizards:pleaseWaitLoadingMachines2' | i18next: { count: notLoadedSelected } }}
        </mbs-alert>
      }
    </mbs-form-group>
  }

  @if (stepForm?.errors?.duplicatesExist) {
    <mbs-alert
      class="duplicatesExistAlert"
      [icon]="true"
      [type]="mbsPopupType.danger">
      {{ 'wizards:selected_virtual_machines_identical_names_alert' | i18next }}
    </mbs-alert>
  }

  @if (!notLoadedSelected && mainService?.machinesDisksStatuses$?.value?.loadingDisks) {
    <mbs-alert
      class="loadingDisksAlert"
      [class.mb-0]="hasAvailableSockets !== false"
      [icon]="true"
      [type]="mbsPopupType.info">
      <span class="d-flex align-items-center overflow-hidden">
        <span class="loader mr-2"></span>
        {{ 'wizards:selected_virtual_machines_checking_alert' | i18next }}
      </span>
    </mbs-alert>
  }

  @if (availableSocketsErrorDetail) {
    <mbs-alert
      class="hasAvailableSocketsAlert"
      [attr.data-e2e]="elementsSelector.name.availableSocketsErrorDetail"
      [icon]="true"
      [type]="mbsPopupType.danger">
      {{ availableSocketsErrorDetail }}
    </mbs-alert>
  }
</form>

<ng-template #searchMachinesModal>
  <div class="form-row mb-3">
    <div [ngClass]="isProxmox ? 'col-8' : 'col-12'">
      <mbs-input
        [clearButton]="true"
        [id]="elementsSelector.id.searchInput"
        [label]="'wizards:searchVirtualMachinesLabel' | i18next"
        [ngModel]="searchQuery"
        [placeholder]="
          (isProxmox ? 'wizards:searchVirtualMachinesPlaceholderProxmox' : 'wizards:searchVirtualMachinesPlaceholder') | i18next
        "
        (ngModelChange)="searchQueryChangeHandler($event)"></mbs-input>
    </div>

    @if (isProxmox) {
      <div class="col-4">
        <mbs-select
          [bindLabel]="'name'"
          [bindValue]="'id'"
          [clearable]="false"
          [id]="elementsSelector.id.searchTypeFilter"
          [items]="typeFilterItems"
          [label]="'wizards:searchVirtualMachinesFilterLabel' | i18next"
          [ngModel]="typeFilter"
          (ngModelChange)="typeFilterChangeHandler($event)"></mbs-select>
      </div>
    }
  </div>

  <mbs-checkbox
    class="mb-2"
    [boldLabel]="true"
    [checked]="allFilteredMachinesSelected"
    [id]="elementsSelector.id.searchSelectAll"
    [indeterminate]="someFilteredMachinesSelected"
    [label]="
      isOffline
        ? ('wizards:selected_virtual_machines_offline' | i18next: { selected: selectedMachines.length })
        : ('wizards:selected_virtual_machines' | i18next: { selected: selectedMachines.length, all: machinesTotal })
    "
    (change)="allMachinesCheckedChangeHandler($event)"></mbs-checkbox>

  <div [style.height]="machineListHeight">
    @if (machineRows.length) {
      <cdk-virtual-scroll-viewport
        class="h-100"
        [itemSize]="machineRowHeight"
        (scrolledIndexChange)="machineRowsScrolledIndexChangeHandler($event)">
        <div
          *cdkVirtualFor="let row of machineRows; trackBy: machineRowTrackBy"
          class="row gx-2 align-items-center"
          [ngClass]="'row-cols-' + columnsCount"
          [style.height.px]="machineRowHeight">
          @for (machine of row; track machine.virtualMachineId) {
            <div class="col overflow-hidden">
              <mbs-checkbox
                [checked]="isMachineSelected(machine)"
                [id]="elementsSelector.id.searchMachineCheckbox + machine.virtualMachineId"
                [label]="machineLabel"
                [labelContext]="machine"
                (change)="machineCheckedChangeHandler(machine, $event)"></mbs-checkbox>
            </div>
          }
        </div>
      </cdk-virtual-scroll-viewport>
    } @else {
      <span class="text-gray-600">{{ 'wizards:searchVirtualMachinesNotFound' | i18next }}</span>
    }
  </div>
</ng-template>

<ng-template
  #machineLabel
  let-machine>
  <span class="d-flex align-items-center overflow-hidden">
    <img
      class="mr-2"
      [alt]="machine[fieldName] + (machine.clusterVm ? ('wizards:selectedVMCluster' | i18next) : '')"
      [src]="isProxmox && machine.itemType === itemTypeEnum.Container ? proxmoxContainerIcon : virtualMachinesIcon" />
    <mbs-text-ellipsis [tooltip]="machine[fieldName]">
      {{ machine[fieldName] }}{{ machine.clusterVm ? ('wizards:selectedVMCluster' | i18next) : '' }}
    </mbs-text-ellipsis>

    @if (machine.invalidName) {
      <span
        class="fa fa-info-circle tooltip-btn text-danger ml-1"
        container="body"
        placement="top"
        [ngbTooltip]="'wizards:selected_virtual_machines_identical_names' | i18next"></span>
    }

    @if (!machine.invalidName && machine.invalidDisks) {
      <span
        class="fa fa-info-circle tooltip-btn text-danger ml-1"
        container="body"
        placement="top"
        [ngbTooltip]="'wizards:selected_virtual_machines_void_disks' | i18next"></span>
    }
  </span>
</ng-template>
